import {AntdTable} from "@/components/custom/AntdTable/AntdTable.jsx";
import {HersRecords} from '@/variants/index.js';

export const HersTable = ({hers}) => {
    const columns = HersRecords.getTableColumns();

	return <AntdTable tableSize={"small"} scroll={500} data={hers} columns={columns} data-testid="hers-table" />;
};
